import { supabase } from './supabase';
import type { MoneyFlowEvent } from '../types/database';

export async function getMoneyFlowEvents(startDate: string, endDate: string): Promise<MoneyFlowEvent[]> {
  const { data, error } = await supabase
    .from('money_flow_events')
    .select('*')
    .gte('event_date', startDate)
    .lte('event_date', endDate)
    .order('event_date', { ascending: false });

  if (error) throw error;
  return (data || []).map(row => ({
    ...row,
    wise_usd_sent: Number(row.wise_usd_sent),
    fee_usd: Number(row.fee_usd),
    exchange_rate_lkr_usd: Number(row.exchange_rate_lkr_usd),
    p2p_rate_lkr_usdt: Number(row.p2p_rate_lkr_usdt),
    usdt_sent: Number(row.usdt_sent),
    mvr_rate_per_usdt: Number(row.mvr_rate_per_usdt),
  }));
}

export async function createMoneyFlowEvent(event: {
  business_id: string;
  business_name: string;
  event_date: string;
  wise_usd_sent: number;
  fee_usd: number;
  exchange_rate_lkr_usd: number;
  p2p_rate_lkr_usdt: number;
  usdt_sent: number;
  mvr_rate_per_usdt: number;
  notes: string;
}): Promise<MoneyFlowEvent> {
  const { data, error } = await supabase
    .from('money_flow_events')
    .insert(event)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function updateMoneyFlowEvent(
  id: string,
  updates: Partial<{
    event_date: string;
    wise_usd_sent: number;
    fee_usd: number;
    exchange_rate_lkr_usd: number;
    p2p_rate_lkr_usdt: number;
    usdt_sent: number;
    mvr_rate_per_usdt: number;
    notes: string;
  }>
): Promise<MoneyFlowEvent> {
  const { data, error } = await supabase
    .from('money_flow_events')
    .update({ ...updates, updated_at: new Date().toISOString() })
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function deleteMoneyFlowEvent(id: string): Promise<void> {
  const { error } = await supabase
    .from('money_flow_events')
    .delete()
    .eq('id', id);

  if (error) throw error;
}

let channelId = 0;
export function subscribeToMoneyFlowEvents(callback: () => void) {
  return supabase
    .channel(`money_flow_events_changes_${++channelId}`)
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'money_flow_events' },
      callback
    )
    .subscribe();
}

export async function getBankRate(): Promise<number> {
  const { data, error } = await supabase
    .from('businesses')
    .select('bank_rate')
    .order('created_at', { ascending: true })
    .limit(1)
    .maybeSingle();

  if (error) throw error;
  return data ? Number(data.bank_rate) : 15.42;
}
